<app-table-standard-layout  [dataSource$]="combObs$" [title]="'Extra data'" [columnSettings]="columnSettings"
  [rowActionButtons]="rowActionButtons" [topbarActionButton]="topbarActionButton" [sortingArray]='sortingArray' [sortByColumn]="'name'">
</app-table-standard-layout>

